
import { Component, Vue, Prop } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

@Component({
  components: {
    vSelect,
  },
})
export default class Select extends Vue {
  @Prop({ default: () => [] })
  private options!: any[];

  @Prop()
  private placeholder!: string;

  @Prop()
  private disabled!: boolean;

  @Prop({ default: "name" })
  private label!: string;

  @Prop()
  private isRouteLink!: boolean;

  @Prop()
  private id!: string;

  @Prop()
  private selected!: any;

  @Prop({ default: () => {} })
  private value!: object;

  reset() {
    if (this.$refs.selectionInput)
      (this.$refs.selectionInput as any).clearSelection();
  }
}
